"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bootcampToUserFacingBootcamp = void 0;
const bootcampToUserFacingBootcamp = ({ startDate, endDate, id, }) => ({
    endDate,
    id,
    startDate,
});
exports.bootcampToUserFacingBootcamp = bootcampToUserFacingBootcamp;
//# sourceMappingURL=mxu_adapters.js.map